import lrNewEditor from './_src/lrNewEditor.vue'

lrNewEditor.install = function(Vue) {
  Vue.component(lrNewEditor.name, lrNewEditor)
}

export default lrNewEditor